import PageViewer from "@/components/PageViewer";

export default {
	path: "DeviceReport",
	// meta: {
	// 	breadcrumb: "Report"
	// },
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/",
			name: "DeviceManager.Verification.DeviceReport",
			props: { pageTransition: "none" },
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification.DeviceReport" */ "@/views/DeviceManager/Verification/DeviceReport/Index"
				)
		},
		{
			path: ":rsuId",
			name: "DeviceManager.Verification.DeviceReport.byRsuId",
			props: route => {
				return { rsuId: route.params.rsuId };
			},
			meta: {
				breadcrumb() {
					return "RSU: " + this.$route.params.rsuId;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification.DeviceReport.byRsuId" */ "@/views/DeviceManager/Verification/DeviceReport/Rsu/Index"
				),
			children: []
		},
		{
			path: ":rsuId/:testsetnum",
			name: "DeviceManager.Verification.DeviceReport.byRsuId.withTestsetnum",
			props: route => {
				return {
					rsuId: route.params.rsuId,
					testsetnum: route.params.testsetnum
				};
			},
			meta: {
				breadcrumb() {
					return "Test #: " + this.$route.params.testsetnum;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification.DeviceReport.byRsuId.withTestsetnum" */ "@/views/DeviceManager/Verification/DeviceReport/Rsu/Testsetnum"
				)
		}
	]
};
